export default __webpack_public_path__ + "static/media/mail.124e64ed.svg";